import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openUserForm } from 'services/forms';
import { OverflowMenu, OverflowMenuItem, Row, Column } from '@carbon/react';
import { Page } from 'components/Page';
import { CustomDataTable } from 'components/Datatable';
import {
  Panel,
  PanelFooter,
  PanelHeader,
  PanelLabel,
  PanelLink,
} from 'components/Panel';
import { SearchBar } from 'components/SearchBar';

import moment from 'moment';
import 'moment/locale/de';

import useModal from '@/lib/hooks/useModal';
import useFilter from '@/lib/hooks/useFilterSettings';
import { useGetMyUsersQuery } from '@/redux/new_services/users';
import { useGetContactsQuery, useGetContactsWithPaginationQuery } from '@/redux/new_services/contacts';

moment.locale('de');

const columns = [
  {
    id: 'firstname',
    title: 'Vorname',
    sortCycle: 'tri-states-from-ascending',
  },
  {
    id: 'lastname',
    title: 'Nachname',
    sortCycle: 'tri-states-from-ascending',
  },
  {
    id: 'mail',
    title: 'Email',
    sortCycle: 'bi-states-from-ascending',
  },
  {
    id: 'phone_number',
    title: 'Telefon',
    sortCycle: 'bi-states-from-ascending',
  },
];

const getRowItems = (rows) => {
  return rows.map((row) => {
    return {
      id: row.model.ID,
      firstname: row.firstname,
      lastname: row.lastname,
      mail: row.mail,
      phone_number: row.phone_number,
      selected: false

    };
  });
};

const RowActions = ({ row }) => {

  const [confirmRemoveContact] = useModal('DELETE_CONTACT');

  const [contactForm] = useModal('CONTACTS_FORM');

  const handleEdit = (userID) => {
    contactForm({id: userID});
  };

  const delete_contact = (userID) => {
    confirmRemoveContact({id: userID})
  };

  return (
    <OverflowMenu flipped aria-label="Menü">
      <OverflowMenuItem
        itemText="Bearbeiten"
        onClick={() => {
          handleEdit(row.id);
        }}
      />
      <OverflowMenuItem
        itemText="Löschen"
        onClick={() => {
          delete_contact(row.id);
        }}
      />
    </OverflowMenu>
  );
};

const ContactsTable = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortBy, setSortBy] = useState({ columnId: 'lastname', direction: 'DESC' });
  const [search, setSearch] = useState(null);
  const [query, setQuery] = useState({pageIndex: page, search: search, order_by: sortBy, pageSize: pageSize});
  const {
    data = {data: {records: [], total_record: 0}},
    isFetching,
  } = useGetContactsWithPaginationQuery(query, {refetchOnMountOrArgChange: false});

  const searchChanged = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    if (sortBy && sortBy.length > 0) {
      const a = sortBy[0].split(' ');
      setSortBy({ sortId: a[0], direction: a[1] || 'ASC' });
    }
  }, [sortBy]);

  useEffect(() => {
    if (data.data.records && data.data.records.length > 0) {
      setRows(getRowItems(data.data.records || [], [], ));
    }
  }, [data]);

  return (
    <>
      <SearchBar searchChanged={searchChanged} labelText={"Kontakt suchen..."}>
      </SearchBar>
      <CustomDataTable
        columns={columns.slice(
          0,
          columns.length
        )}
        search={search}
        rows={rows}
        sortInfo={sortBy}
        loadItems={({
          pageSize: newPageSize,
          pageIndex: newPageIndex,
          sortBy: newSortBy,
        }) => {
          setPageSize(newPageSize);
          setQuery(f => { return {...f, pageIndex: newPageIndex, search: search, sortBy: newSortBy, pageSize: newPageSize}});
          setPage(newPageIndex);
          if (newSortBy !== sortBy && newSortBy !== undefined) {
            setSortBy(newSortBy);
          }
        }}
        totalItems={data.data?.total_record || 0}
        pageSize={pageSize}
        page={page}
        hasExpandedRow={false}
        customRowActionsComponent={RowActions}
        isLoading={isFetching}
      />

      <br/>
      <br/>
    </>
  );
};

export const Contacts = () => {
  const [contactForm] = useModal('CONTACTS_FORM');

  return (
    <Page
      pageClass="contacts-page"
      mainContentClass="contacts-page__r2"
      pageTitle="Kontakt Übersicht"
    >
      <Row>
        <Column md={5}>
          <Row className="small_row">
            <Column md={4}>
              <Panel halfSize>
                <PanelHeader header>
                  Kontakte hinzufügen
                </PanelHeader>
                <PanelLabel>
                  Kontakte können in Standorte als Technische Ansprechpartner hinterlegt werden. Diese können dann Automatisch bei Fehlern per mail benachrichtigt werden.
                </PanelLabel>
                <PanelFooter>
                  <PanelLink onClick={() => contactForm("new")}>
                    KONTAKT HINZUFÜGEN &gt;
                  </PanelLink>
                </PanelFooter>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
      <Row>
        <Column>
          <ContactsTable />
        </Column>
      </Row>
    </Page>
  );
};
